export default "__VITE_ASSET__DbL5Pcoi__"